export async function copyTextToClipboard(text) {
  const value = String(text || "");
  if (!value) throw new Error("Nothing to copy.");

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return "clipboard";
    }
  } catch {
    // Embedded browsers can reject navigator.clipboard even for a user click.
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "-9999px";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  try {
    if (!document.execCommand?.("copy")) {
      throw new Error("Copy command failed.");
    }
    return "fallback";
  } finally {
    document.body.removeChild(textarea);
  }
}
